import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_REPORTS_PATH,
  GetOrganizationReportsErrorDto,
  GetOrganizationReportsSuccessDto,
} from '@/api/rest/resources/types/organization';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetOrganizationReportsSuccessDto;
type ErrorDto = GetOrganizationReportsErrorDto;

export const useOrganizationReports = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const pathParams = { organization_id: organizationId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_REPORTS_PATH, pathParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', 'reports', pathParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
